import { action, observable, makeObservable } from 'mobx';
import { Logger } from '../../services';
import { UserMutator } from '../../services/user.service';

export class ForgotPasswordCtrl {
	@observable loading = false;
	@observable completedReset = false;

	constructor() {
		makeObservable(this);
	}

	requestPasswordReset(emailAddress: string) {
		this.setLoading(true);

		const normalizedEmailAddress = emailAddress.trim().toLowerCase();

		return UserMutator.requestPasswordReset(normalizedEmailAddress)
			.then(() => {
				this.setLoading(false);
				this.setCompletedReset(true);
			})
			.catch((e) => {
				Logger.error(e);
				this.setLoading(false);
			});
	}

	isValidEmail(value: string | null): boolean {
		if (typeof value !== 'string') {
			return false;
		}

		const emailAddress = value.trim();
		const firstIndex = emailAddress.indexOf('@');
		const lastIndex = emailAddress.lastIndexOf('@');

		return firstIndex > 0 && firstIndex === lastIndex && lastIndex < emailAddress.length - 1;
	}

	@action setLoading(loading: boolean) {
		this.loading = loading;
	}

	@action setCompletedReset(completed: boolean) {
		this.completedReset = completed;
	}
}
